import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ToggleItemTextVisibilityButtonComponent } from "@components/toggle-item-text-visibility-button/toggle-item-text-visibility-button.component";
import { ToggleLockButtonComponent } from "@components/toggle-lock-button/toggle-lock-button.component";
import { ToggleVisibilityButtonComponent } from "@components/toggle-visibility-button/toggle-visibility-button.component";
import { FloorplanState } from "@domain/project/floorplan/floorplan-state";
import { WildcardZoneType } from "@domain/project/floorplan/zones/wildcard-zone";
import { FloorplanZonesService } from "@project/floorplan-zones.service";
import { FloorplanMenuItemButtonsComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-item-buttons/floorplan-menu-item-buttons.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-floorplan-wildcard-zone-menu",
  templateUrl: "./floorplan-wildcard-zone-menu.component.html",
  styleUrls: ["./floorplan-wildcard-zone-menu.component.scss"],
  imports: [
    UiKitModule,
    FloorplanMenuItemButtonsComponent,
    ToggleVisibilityButtonComponent,
    ToggleLockButtonComponent,
    ToggleItemTextVisibilityButtonComponent,
  ],
})
export class FloorplanWildcardZoneMenuComponent {
  private floorplanService = inject(FloorplanService);
  private floorplanZonesService = inject(FloorplanZonesService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplanState: FloorplanState;
  protected readonly WildcardZoneType = WildcardZoneType;
  protected readonly tooltipTextAddWildcardZone = (type: number) =>
    $localize`:@@floorplan.button.addWildcardZone:Variable Zone ${type}:wildcardZoneType: platzieren`;

  constructor() {
    this.floorplanState = this.floorplanService.selectedFloorplan.floorplanState;
  }

  protected addWildcardZone(zoneType: WildcardZoneType) {
    this.floorplanZonesService.addWildcardZone(zoneType);
  }

  protected dragWildcardZone(zoneType: WildcardZoneType) {
    this.dragDropService.setDragged({ type: DraggedItemType.WILDCARD_ZONE, config: zoneType });
  }

  protected updateWildcardZonesItemTextVisibility(visible: boolean) {
    this.floorplanState.updateWildcardZonesItemTextVisibility(visible);
  }
}
